
import React from 'react'
import { Box, Grid } from '@mui/material'
import CustomCardWithGraph from '../../common/card/CustomCardWithGraph'


const WeekGraph = ({data}) => {

  const transformedData = data.map(item => ({
    name: item?.label?.slice(0,3), 
    totalRevenue: item?.totalRevenue, 
    totalSales: item?.totalSales 
  }));

 


  return (
    <Box mb={4} mt={3}>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
      <CustomCardWithGraph
          title="Total Revenue"
          data={transformedData}
          dataKey="totalRevenue" 
          // barColor="url(#colorUv)"
          customStyles={{ minWidth: '280px' }}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
      <CustomCardWithGraph
          title="Total Sales"
          data={transformedData}
          dataKey="totalSales" 
          // barColor=""
          customStyles={{ minWidth: '280px' }}
        />
      </Grid>
    </Grid>
  </Box>
  )
}

export default WeekGraph